import {inject} from '@angular/core';
import {HttpContextToken, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {StorageService} from '../../services/storage-service';

export const SKIP_AUTHORIZATION_HEADER_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const storage = inject(StorageService);

  // Remove any undefined params
  let params = req.params;
  for (const key of req.params.keys()) {
    if (params.get(key) === undefined) {
      params = params.delete(key, undefined);
      console.debug(`[authInterceptor] - deleted params [${key}] from [${req.url}] because it was undefined`)
    }
  }
  req = req.clone({params})

  // Setting the authorization token
  const token = storage.get('token');
  const skipAuthorizationHeaderInterceptor = req.context.get(SKIP_AUTHORIZATION_HEADER_INTERCEPTOR)
  if (!skipAuthorizationHeaderInterceptor) {
    if (token) {
      req = req.clone({headers: req.headers.set('Authorization', token)});
    }
  }

  return next(req);
}
